import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreSubscriptionData } from "../types";
import { intcmpMap } from "../../../utils/intcmp";
import { UpdateSdapiLiveScoreWidgetInputSchema } from "appsync";

const isValidObject = (obj: LiveScoreSubscriptionData) =>
  Boolean(obj?.data?.onUpdateSdapiLiveScoreById);

export const transformSubscription = (obj: LiveScoreSubscriptionData): Omit<ITennisLiveScore, 'ctaUrls'> => {
  if (isValidObject(obj)) {
    UpdateSdapiLiveScoreWidgetInputSchema().parse(obj.data.onUpdateSdapiLiveScoreById, { reportInput: true });

    const { liveTournaments } = obj?.data?.onUpdateSdapiLiveScoreById;

    return {
      liveTournaments,
      resultsIntcmp: intcmpMap.liveScoreAtpResults,
    } as Omit<ITennisLiveScore, 'ctaUrls'>;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LiveScoreSubscription object',
      data: obj
    });
  }
};